import { useSafeState, useUnmountRef } from '@atomica.co/components';
import { useEffect } from 'react';
import { Process } from '../../enums/common-enum';
import { toProcessAction } from '../actions/process-action';
import store from '../store';

interface P {
  process: Process;
  setProcess: React.Dispatch<React.SetStateAction<Process>>;
}

function useProcess() {
  const unmountRef = useUnmountRef();
  const [process, setProcess] = useSafeState<Process>(unmountRef, store.getState().process);

  useEffect(() => {
    if (!process) return;
    const action = toProcessAction(process);
    store.dispatch(action);
  }, [process]);

  return {
    process,
    setProcess
  } as P;
}

export default useProcess;
